import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BASE } from "../api/client";


// URL API ajustée à ta configuration urls.py
const API_URL = `${BASE}/api/auth/admin-panel/users/`;

export default function UserManagementPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  const [form, setForm] = useState({
    email: "",
    username: "",
    password: "",
    is_staff: false,
  });

  const getHeaders = () => {
    const token =
      localStorage.getItem("access") || localStorage.getItem("accessToken");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL, { headers: getHeaders() });
      if (res.status === 401 || res.status === 403) {
        setError("Accès refusé. Vous devez être administrateur.");
      } else if (res.ok) {
        const data = await res.json();
        setUsers(data);
        setError("");
      } else {
        setError("Erreur chargement données.");
      }
    } catch (err) {
      setError("Erreur connexion serveur.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setMsg("Utilisateur créé !");
        setForm({ email: "", username: "", password: "", is_staff: false });
        fetchUsers();
      } else {
        const d = await res.json();
        setError("Erreur: " + JSON.stringify(d));
      }
    } catch (err) {
      setError("Erreur réseau.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cet utilisateur ?")) return;
    try {
      const res = await fetch(`${API_URL}${id}/`, {
        method: "DELETE",
        headers: getHeaders(),
      });
      if (res.ok) fetchUsers();
      else alert("Erreur suppression.");
    } catch (err) {
      alert("Erreur réseau");
    }
  };

  const toggleAdmin = async (id, currentVal) => {
    try {
      const res = await fetch(`${API_URL}${id}/`, {
        method: "PATCH",
        headers: getHeaders(),
        body: JSON.stringify({ is_staff: !currentVal }),
      });
      if (res.ok) fetchUsers();
    } catch (err) {
      alert("Erreur réseau");
    }
  };

  if (loading) return <div style={{ padding: 20 }}>Chargement...</div>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        padding: 20,
        maxWidth: 1000,
        margin: "0 auto",
        fontFamily: "sans-serif",
      }}
    >
      {/* HEADER AVEC ICON POLYGLOW QUI RAMÈNE À LA HOME */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 20,
          justifyContent: "space-between",
        }}
      >
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "#111",
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, #ff6b6b, #f8e71c, #50e3c2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 16,
              marginRight: 8,
            }}
          >
            P
          </div>
          <span style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
            Polyglow
          </span>
        </Link>
      </div>

      <h2>Gestion des Utilisateurs</h2>
      {error && (
        <div
          style={{
            background: "#f8d7da",
            color: "#721c24",
            padding: 10,
            marginBottom: 10,
            borderRadius: 4,
          }}
        >
          {error}
        </div>
      )}
      {msg && (
        <div
          style={{
            background: "#d4edda",
            color: "#155724",
            padding: 10,
            marginBottom: 10,
            borderRadius: 4,
          }}
        >
          {msg}
        </div>
      )}

      <div
        style={{
          background: "#f8f9fa",
          padding: 15,
          borderRadius: 5,
          marginBottom: 20,
          border: "1px solid #ddd",
        }}
      >
        <h3>Ajouter un utilisateur</h3>
        <form
          onSubmit={handleCreate}
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
            alignItems: "flex-end",
          }}
        >
          <div style={{ flex: 1 }}>
            <label style={{ display: "block", fontSize: "0.8em" }}>Email</label>
            <input
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              style={{ padding: 8, width: "100%" }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: "block", fontSize: "0.8em" }}>
              Username
            </label>
            <input
              type="text"
              required
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              style={{ padding: 8, width: "100%" }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: "block", fontSize: "0.8em" }}>
              Mot de passe
            </label>
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              style={{ padding: 8, width: "100%" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingBottom: 8,
            }}
          >
            <label
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 5,
              }}
            >
              <input
                type="checkbox"
                checked={form.is_staff}
                onChange={(e) =>
                  setForm({ ...form, is_staff: e.target.checked })
                }
              />{" "}
              Staff?
            </label>
          </div>
          <button
            type="submit"
            style={{
              padding: "8px 16px",
              background: "#007bff",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: 4,
            }}
          >
            Créer
          </button>
        </form>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ textAlign: "left", background: "#343a40", color: "white" }}>
            <th style={{ padding: 10 }}>Email</th>
            <th style={{ padding: 10 }}>Username</th>
            <th style={{ padding: 10 }}>Rôle</th>
            <th style={{ padding: 10 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ padding: 10 }}>{u.email}</td>
              <td style={{ padding: 10 }}>{u.username}</td>
              <td style={{ padding: 10 }}>
                {u.is_superuser ? (
                  <b style={{ color: "red" }}>SuperAdmin</b>
                ) : (
                  <button
                    onClick={() => toggleAdmin(u.id, u.is_staff)}
                    style={{
                      background: u.is_staff ? "orange" : "#17a2b8",
                      color: "white",
                      border: "none",
                      padding: "3px 8px",
                      cursor: "pointer",
                      borderRadius: 4,
                    }}
                  >
                    {u.is_staff ? "Admin (Retirer)" : "Membre (Promouvoir)"}
                  </button>
                )}
              </td>
              <td style={{ padding: 10 }}>
                {!u.is_superuser && (
                  <button
                    onClick={() => handleDelete(u.id)}
                    style={{
                      background: "#dc3545",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      cursor: "pointer",
                      borderRadius: 4,
                    }}
                  >
                    Supprimer
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </motion.div>
  );
}
